import { AlgoliaMapBounds } from '../types/AuctionsNearMe.types';

export const defaultHitsPerPage = 24;

// Rectangle around the US
export const defaultAuctionsNearMeBounds: AlgoliaMapBounds = {
    northEast: {
        lat: 46.4,
        lng: -64.3,
    },
    southWest: {
        lat: 28.7,
        lng: -123.4,
    },
};
